import type { CrmAppointment } from "./types";

const icsEscape = (value: string): string =>
  value.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\r?\n/g, "\\n");

const icsDate = (iso: string): string => {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;
};

/** Download one appointment as a .ics file any calendar app can import. */
export function downloadAppointmentIcs(appointment: CrmAppointment): void {
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//TechLadder//CRM//EN",
    "BEGIN:VEVENT",
    `UID:${appointment.id}@techladder-crm`,
    `DTSTAMP:${icsDate(new Date().toISOString())}`,
    `DTSTART:${icsDate(appointment.dueAt)}`,
    `SUMMARY:${icsEscape(`Meeting: ${appointment.name || appointment.phone || "Lead"}`)}`,
    `DESCRIPTION:${icsEscape(appointment.note || "")}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ];
  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `appointment-${appointment.id}.ics`;
  link.click();
  URL.revokeObjectURL(url);
}
